export const getAppAccessList = (user = {}) => {
    return [
        {
            title: "ESS",
            subTitle: "Employee Self Service",
            link: user.ess_domain,
            img: "/accounts/img/svg/hrms.svg",
            backgroundColor: "rgba(51, 90, 255, 0.05)",
            display:
            user.ess_domain && user?.subs?.app_ids.indexOf(2) > -1 &&
                (user.role_ids.indexOf(8) > -1 ||
                    user.role_ids.indexOf(7) > -1),
        },
        {
            title: "HRMS",
            subTitle: "Human Resource Management System",
            link: user.admin_domain,
            img: "/accounts/img/svg/admin.svg",
            backgroundColor: "rgba(51, 90, 255, 0.05)",
            display: user.admin_domain && user?.subs?.app_ids.indexOf(1) > -1 && (user.role_ids.indexOf(2) > -1 || user?.role_ids.includes(8)),
        },
        {
            title: "Performance",
            subTitle: "Monitor employee Performance",
            link: user.pms_domain,
            img: "/accounts/img/svg/pm.svg",
            backgroundColor: "rgba(0, 205, 55, 0.05)",
            display: user.pms_domain && user?.subs?.app_ids.indexOf(6) > -1 && user.PMS,
        },
        {
            title: "Payroll",
            subTitle: "Seamless Payment",
            img: "/accounts/img/svg/payroll.svg",
            link: user.payroll_domain,
            backgroundColor: "rgba(250, 200, 0, 0.05)",
            display:
            user.payroll_domain && (user?.subs?.app_ids.indexOf(3) > -1 || user?.subs?.app_ids.indexOf(5) > -1) && (user.role_ids.indexOf(2) > -1 || user.role_ids.indexOf(9) > -1),
        },
        {
            title: "ATS",
            subTitle: "Applicant Tracking System",
            link: user.ats_domain,
            img: "/accounts/img/svg/ats.svg",
            backgroundColor: "rgba(221, 79, 36, 0.05)",
            display: user.ats_domain && user?.subs?.app_ids.indexOf(7) > -1 && user.IS_ACTIVE_ATS,
        },
        {
            title: "LMS",
            subTitle: "Learning management system",
            link: user.lms_domain,
            img: "/accounts/img/svg/ats.svg",
            backgroundColor: "rgba(221, 79, 36, 0.05)",
            display: (user.lms_domain && user?.subs?.app_ids.indexOf(11) > -1 && (user.role_ids.indexOf(7) > -1 || user.role_ids.indexOf(17) > -1)),
        },
    ].filter((item) => item.display)
}